/* @ngInject */

export default () => (input, type, label, owner) => {
  let out = [];
  if (!type && !label && !owner) {
    out = input;
  } else {
    out = input.filter((note) => {
      let output = false;
      if (type && !label && !owner) {
        output = note?.type === type || note?.type?.name === type;
      }
      if (label) {
        output = type
          ? (note?.type === type || note?.type?.name === type) &&
            note?.idLabels.indexOf(label) > -1
          : note?.idLabels.indexOf(label) > -1;
      }
      if (owner === 'users') {
        if (type && label) {
          output =
            (note?.type === type || note?.type?.name === type) &&
            note?.idLabels.indexOf(label) > -1 &&
            !note?.idOwnerContact &&
            !note?.idOwnerPartner;
        } else if (type && !label) {
          output =
            (note?.type === type || note?.type?.name === type) &&
            !note?.idOwnerContact &&
            !note?.idOwnerPartner;
        } else if (!type && label) {
          output =
            note?.idLabels.indexOf(label) > -1 &&
            !note?.idOwnerContact &&
            !note?.idOwnerPartner;
        } else {
          output = !note?.idOwnerContact && !note?.idOwnerPartner;
        }
      }
      if (owner === 'clients') {
        if (type && label) {
          output =
            (note?.type === type || note?.type?.name === type) &&
            note?.idLabels.indexOf(label) > -1 &&
            note?.idOwnerContact;
        } else if (type && !label) {
          output = (note?.type === type || note?.type?.name === type) && note?.idOwnerContact;
        } else if (!type && label) {
          output = note?.idLabels.indexOf(label) > -1 && note?.idOwnerContact;
        } else {
          output = note?.idOwnerContact;
        }
      }
      if (owner === 'referrers') {
        if (type && label) {
          output =
            (note?.type === type || note?.type?.name === type) &&
            note?.idLabels.indexOf(label) > -1 &&
            note?.idOwnerPartner;
        } else if (type && !label) {
          output = (note?.type === type || note?.type?.name === type) && note?.idOwnerPartner;
        } else if (!type && label) {
          output = note?.idLabels.indexOf(label) > -1 && note?.idOwnerPartner;
        } else {
          output = note?.idOwnerPartner;
        }
      }
      return output;
    });
  }
  return out;
};
